import { BORN_ALIVE, BORN_ALIVE_RESIGNED, DECEASED, STILLBORN } from '../vitality';

export default {
  BORN_ALIVE: BORN_ALIVE.id,
  STILLBORN: STILLBORN.id,
  BORN_ALIVE_RESIGNED: BORN_ALIVE_RESIGNED.id,
  BORN_ALIVE_DECEASED_WITHIN_WEEK: 'born_alive_deceased_within_week',
  DECEASED: DECEASED.id,
};
